import { useTranslation } from "react-i18next";
import { IconButton, SvgIcon, Tooltip } from "@mui/material";
import { useDialog } from "@hooks/shared/use-dialog";
import { SearchDialog } from "@components/shared/elements/search-dialog";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMagnifyingGlass } from "@fortawesome/pro-regular-svg-icons";

export const SearchButton = () => {
  const dialog = useDialog();
  const { t } = useTranslation();

  return (
    <>
      <Tooltip title={t("common.search")}>
        <IconButton onClick={dialog.handleOpen}>
          <SvgIcon>
            <FontAwesomeIcon color="white" icon={faMagnifyingGlass} />
          </SvgIcon>
        </IconButton>
      </Tooltip>
      <SearchDialog open={dialog.open} onClose={dialog.handleClose} />
    </>
  );
};
